import { To } from 'react-router-dom';

import { BreadcrumbItem, BreadcrumbItemProps, HStack, OnOutlineHome, Text } from '@oaknorth/component-core-v2';

import { InternalTextLink, InternalTextLinkProps } from '../InternalTextLink';

export interface BreadcrumbLinkItemProps extends BreadcrumbItemProps {
  to: To;
  linkProps?: Omit<InternalTextLinkProps, 'to'>;
  ref?: React.RefObject<HTMLDivElement | null>;
}
export const BreadcrumbLinkItem = function BreadcrumbLinkItem({ ref, ...props }: BreadcrumbLinkItemProps) {
  const { children, to, linkProps, isHomePage, ...rest } = props;

  return (
    <BreadcrumbItem ref={ref} {...rest}>
      <InternalTextLink to={to} {...linkProps} fontWeight="normal" color="fg.muted">
        {props.isHomePage ? (
          <HStack gap={1}>
            <OnOutlineHome boxSize={4} viewBox="0 0 16 16" />
            <Text>{children}</Text>
          </HStack>
        ) : (
          children
        )}
      </InternalTextLink>
    </BreadcrumbItem>
  );
};
